import axiosInstance from "../axiosInstance";

import {
	FETCH_REPORTS_REQUEST,
	FETCH_REPORTS_SUCCESS,
	FETCH_REPORTS_FAIL,
} from "../constants/spinTheWheelReport";

const fetchSpinReports = (params) => async (dispatch, getState) => {
	const {
		login: { adminInfo },
	} = getState();

	dispatch({ type: FETCH_REPORTS_REQUEST });
	try {
		const { data } = await axiosInstance.get("/admin/spins/report", {
			params,
			headers: {
				Authorization: "Bearer " + adminInfo.authToken,
			},
		});

		dispatch({
			type: FETCH_REPORTS_SUCCESS,
			payload: data,
		});
	} catch (error) {
		console.log("error: ", error);
		const errorMessage = error.response.data.error;
		dispatch({ type: FETCH_REPORTS_FAIL, payload: errorMessage });
	}
};

export { fetchSpinReports };
